import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './UserLogin.css';

const UserLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get('redirect') || '/perfil';

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        navigate(redirectPath, { replace: true });
      }
    });
    return () => unsubscribe();
  }, [navigate, redirectPath]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err: any) {
      setError('E-mail ou senha incorretos.');
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    try {
      await signInWithPopup(auth, provider);
      navigate(redirectPath, { replace: true });
    } catch (err: any) {
      console.error(err);
      setError('Erro ao entrar com Google.');
    }
    setLoading(false);
  };

  return (
    <div className="user-login-page container">
      <div className="login-card">
        <h2>Acesso do Participante</h2>
        <p>Entre para confirmar sua presença ou baixar seu certificado.</p>

        <button onClick={handleGoogleLogin} className="btn-google" disabled={loading}>
          {loading ? 'Carregando...' : 'Entrar com Google'}
        </button>

        <div className="divider"><span>ou use seu e-mail</span></div>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" autoComplete="username email" required />
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="******" autoComplete="current-password" required />
          </div>
          {error && <p className="error-msg">{error}</p>}
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Processando...' : 'Entrar na Conta'}
          </button>
        </form>

        <div className="login-footer">
          <p>Ainda não se inscreveu? <Link to="/inscricao">Realizar Inscrição</Link></p>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
